import axios from "@/axios/index";
export function sendYzm(mobile,event){
  return axios.post("/api/sms/sendMy",{mobile:mobile,event:event})
}
